<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'参展申请' | dealLanguage('Exhibition application')}}</page-header>
    <div class="center-wrapper">
      <div class="top-tip" v-if="language == 'zh'">
        您好，感谢您关注<span>{{activityDetail.name}}</span>！<br />
        填写参展申请信息，工作人员会尽快与您联系。<br />
        如有任何问题，敬请电话咨询：<span>18523659972</span>。
      </div>
      <div class="top-tip" v-if="language == 'en'">
        Thank you for your attention in <span>{{activityDetail.enName}}</span>！<br />
        Please fill in the exhibition application information and our staff will contact you as soon as possible. <br />
        If you have any questions, please call:<span>18523659972</span>.
      </div>
      <div class="form-view">
        <Form ref="current-form" :model="currentForm" :rules="ruleValidate">
          <div class="view-title">
            <div class="title">{{'预登记信息' | dealLanguage('Pre-registration Form')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="entityName" :label="'公司' | dealLanguage('Company Name')">
            <Input type="text" v-model="currentForm.entityName" :placeholder="'请填写公司名称'| dealLanguage('Please fill in the company name')"></Input>
          </FormItem>
          <FormItem prop="contactName" :label="'联系人姓名' | dealLanguage('Name')">
            <Input type="text" v-model="currentForm.contactName" :placeholder="'请填写联系人姓名'| dealLanguage('Please fill in your name')"></Input>
          </FormItem>
          <FormItem prop="mobile" :label="'联系人手机号' | dealLanguage('Phone Number')">
            <Input type="text" v-model="currentForm.mobile" :placeholder="'请填写联系人手机号'| dealLanguage('Please enter your mobile number')"></Input>
          </FormItem>
          <Row :gutter="26">
            <Col span="12">
            <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
              <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门'| dealLanguage('Please fill in the department')"></Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
              <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位'| dealLanguage('Please fill in the position')"></Input>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="summary" :label="'主推/主营产品名称' | dealLanguage('Main Products')">
            <Input type="text" v-model="currentForm.summary" :placeholder="'请填写主推/主营产品名称'| dealLanguage('Please fill in the name of the main product')"></Input>
          </FormItem>
          <FormItem prop="mainPage" :label="'公司网址' | dealLanguage('Company Websits')">
            <Input type="text" v-model="currentForm.mainPage" :placeholder="'请填写公司网址'| dealLanguage('Please fill in the company website')"></Input>
          </FormItem>
          <FormItem prop="need" :label="'主要参展需求（多选）' | dealLanguage('Requirements(multi-select)')">
            <CheckboxGroup v-model="currentForm.need" @on-change="handleChangeNeed">
              <Checkbox :label="item" v-for="item,index in needList" :key="index"></Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem prop="needother" v-if="needother">
            <Input type="text" v-model="currentForm.needother" :placeholder="'请填写具体需求'| dealLanguage('Please fill in your specific requirements')"></Input>
          </FormItem>
        </Form>
        <div class="btn-wrapper">
          <Button type="primary" @click="handleSubmit" :loading="buttonLoading">
            <span v-if="buttonLoading">{{'保存中' | dealLanguage('Loading')}}</span>
            <span v-else>{{'保存' | dealLanguage('Submit')}}</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addCompEnrollment } from '@/service/vbef'
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('参展申请', 'Exhibition application'),
    }
  },
  inject: ['login', 'wxShare'],
  components: {
    PageHeader,
  },
  created() {
    if (this.user_key) {
      this.currentForm.contactName = this.user.name
      this.currentForm.mobile = this.user.mobile
      this.currentForm.entityName = this.user.compName
      this.currentForm.department = this.user.department
      this.currentForm.title = this.user.title
    }
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('参展申请-2025VBEF大会', 'Exhibition application-2025VBEF Conference'),
      linkurl: this.vbef_path + '/compReg',
      
    })
  },
  data() {
    return {
      filter,
      buttonLoading: false,
      currentForm: {
        activityId: 0,
        contactName: '',
        department: '',
        entityName: '',
        mainPage: '',
        mobile: '',
        summary: '',
        title: '',
        need: [],
        needother: '',
      },
      ruleValidate: {
        contactName: [{ required: true, message: filter.dealLanguage('请填写姓名', 'Please fill in your name'), trigger: 'blur' }],
        mobile: [
          { required: true, message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'), trigger: 'blur' },
          {
            type: 'number',
            message: filter.dealLanguage('手机号格式不正确', 'The phone number format is incorrect'),
            trigger: 'blur',
            transform(value) {
              return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
        entityName: [{ required: true, message: filter.dealLanguage('请填写企业名称', 'Please fill in the company name'), trigger: 'blur' }],
        department: [{ required: true, message: filter.dealLanguage('请填写部门', 'Please fill in the department'), trigger: 'blur' }],
        title: [{ required: true, message: filter.dealLanguage('请填写职位', 'Please fill in the position'), trigger: 'blur' }],
        need: [{ required: true, type: 'array', message: filter.dealLanguage('请选出主要参展需求', 'Please select your main exhibition requirements'), trigger: 'change'}],
        needother: [{ required: true, message: filter.dealLanguage('请填写具体需求', 'Please fill in the specific requirements'), trigger: 'blur' }],
        summary: [{ required: true, message: filter.dealLanguage('请填写主推/主营产品名称', 'Please fill in the name of the main product'), trigger: 'blur' }],
      },
      needother: false,
      needList: [
        filter.dealLanguage('申请展位参展', 'Apply for a stand to participate in the exhibition'),
        filter.dealLanguage('在主办方的大会论坛中进行演讲赞助', "Sponsor a speech at the conference"),
        filter.dealLanguage('在大会同期自主举办独立卫星会', 'Host a satellite conference concurrently with the main conference'),
        filter.dealLanguage('会前在动脉网平台进行线上文章宣传', 'Promote articles on The VBDATA before the conference'),
        filter.dealLanguage('会前在动脉网平台进行线上会议直播', 'Live-stream the meeting on The VBDATA before the conference'),
        filter.dealLanguage('在现场活动区进行赞助', 'Sponsorship within the venue'),
        filter.dealLanguage('进行现场户外广告赞助', 'Sponsorship of outdoor advertising'),
        filter.dealLanguage('其他', 'Others'),
      ],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    handleSubmit() {
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          this.currentForm.activityId = this.activityId
          let needJson = {
            need: this.currentForm.need,
            needother: this.currentForm.needother
          }
          this.currentForm.checkFormJson = JSON.stringify(needJson)
          const { need, needother, ...params } = this.currentForm
          let res = await addCompEnrollment(params)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$notify({ type: 'success', message: this.language == 'zh' ? '提交成功！' : 'Submit successful' })
            this.$router.push({ name: 'index' })
          } else {
            this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    handleChangeNeed(arr) {
      this.needother = false
      for (let item of arr) {
        if (item.indexOf('其他') > -1 || item.indexOf('Other')> -1) {
          this.needother = true
          break
        }
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
.center-wrapper
  padding-top 0.3rem
  .top-tip
    font-size 0.26rem
    color #3D3D3D
    line-height 0.48rem
    text-align justify
    margin 0 0.4rem
    a
    span
      color #FA5A00
</style>